import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-uiform-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css'],
})
export class SideMenuComponent {
  constructor(private router: Router) {}

  @Input() uiformId: number | null = 0; // pass as a input
  @Input() targetId: any;

  @Input() appId: any;
  @Input() usecaseId: any;

  // goBack() {
  //   if (this.usecaseId) {
  //     this.router.navigate(['/uiformcreate/' + this.usecaseId]);
  //   }
  // }
  goBack() {
    window.history.back(); // Navigates to the previous page
  }

  getClass(active: any) {
    if (this.targetId === active) {
      return 'nav-link active btn-link bg-secondary';
    } else {
      return 'nav-link  btn-link text-secondary';
    }
  }

  // getAiIcon(active: string) {
  //   const isActive = this.targetId === active;
  //   return isActive
  //     ? 'assets/images/icons/ai-white.png' // active
  //     : 'assets/images/icons/ai-black.png'; // inactive
  // }
  getAiIcon(active: string) {
    const isActive = this.targetId === active;
    const isDark = document.documentElement.classList.contains('dark-theme');

    if (isDark) {
      return isActive
        ? 'assets/images/icons/ai-white.png' // active in dark
        : 'assets/images/icons/ai-white.png'; // inactive in dark (usually white for visibility)
    }

    // light theme
    return isActive
      ? 'assets/images/icons/ai-white.png' // active in light
      : 'assets/images/icons/ai-black.png'; // inactive in light
  }
}
